import { useToastStore, type ToastType } from './toastStore'

const COLORS: Record<ToastType, { bg: string; border: string; text: string }> = {
  success: { bg: '#ecfdf5', border: '#a7f3d0', text: '#065f46' },
  error: { bg: '#fef2f2', border: '#fecaca', text: '#991b1b' },
  info: { bg: '#eff6ff', border: '#bfdbfe', text: '#1e40af' },
}

/**
 * Стопка тостов в правом нижнем углу. Монтируется в App.
 * Авто-скрытие — в сторе (5с); клик закрывает раньше.
 */
export function ToastHost() {
  const toasts = useToastStore((s) => s.toasts)
  const dismiss = useToastStore((s) => s.dismiss)

  if (toasts.length === 0) return null

  return (
    <div
      style={{
        position: 'fixed',
        bottom: 20,
        right: 20,
        display: 'flex',
        flexDirection: 'column',
        gap: 10,
        zIndex: 9999,
        maxWidth: 'min(420px, calc(100vw - 40px))',
      }}
    >
      {toasts.map((t) => {
        const c = COLORS[t.type]
        return (
          <div
            key={t.id}
            role="status"
            onClick={() => dismiss(t.id)}
            style={{
              background: c.bg,
              border: `1px solid ${c.border}`,
              color: c.text,
              borderRadius: 10,
              padding: '12px 16px',
              fontSize: 13,
              lineHeight: 1.4,
              boxShadow: '0 6px 24px rgba(0,0,0,0.12)',
              cursor: 'pointer',
              whiteSpace: 'pre-line',
            }}
          >
            {t.text}
          </div>
        )
      })}
    </div>
  )
}
